import { useEffect, useState } from 'react';
import { verificarAcessoAdmin, type AcessoAdminUpavet } from '@/utils/upavet';

/**
 * Verifica, ao entrar, se o usuário logado tem acesso às views administrativas
 * do UPA VET (checagem por e-mail no JWT). Enquanto a sonda não responde, o estado
 * fica em "indisponivel" — e o menu é mantido, para não esconder por engano.
 *
 * O 403 vindo da sonda é tratado como PERMISSÃO (não sessão): não renova token
 * nem desloga — apenas sinaliza "negado" para esconder os itens restritos.
 */
export function useAcessoAdminUpavet(): AcessoAdminUpavet {
  const [estado, setEstado] = useState<AcessoAdminUpavet>('indisponivel');

  useEffect(() => {
    let ativo = true;
    verificarAcessoAdmin()
      .then((r) => {
        if (ativo) setEstado(r);
      })
      .catch(() => {
        if (ativo) setEstado('indisponivel');
      });
    return () => {
      ativo = false;
    };
  }, []);

  return estado;
}